import React, { useState, useEffect } from 'react';
import Checkbox from '../../Elements/Checkbox';

const MenuTypes = {
  NumberOp: 'NumberOp',
  SuggestionOp: 'SuggestionOp',
};

export default (props) => {
  const { item, doUpdateItem } = props;
  const [options, setOptions] = useState(
    item.menuOptions || { NumberOp: true, SuggestionOp: false }
  );

  const onAcceptedFileChanged = (e, type) => {
    const newOptions = { ...options, [type]: e.target.checked };
    setOptions(newOptions);
    doUpdateItem({ menuOptions: newOptions });
  };

  useEffect(() => {
    if (item && item.menuOptions) {
      setOptions(item.menuOptions);
    }
  }, [item]);

  return (
    <div className="menu-right-settings-container">
      <div className="menu-error-message-container">
        <strong>No Webchat</strong>
      </div>
      <div className="mt-1">
        <Checkbox
          label="Exibir opções numéricas"
          type={MenuTypes.NumberOp}
          checked={options.NumberOp}
          onChange={(e, type) => onAcceptedFileChanged(e, type)}
        />
        <div className="menu-right-settings-checkbox">
          <Checkbox
            label="Exibir botões de sugestão"
            type={MenuTypes.SuggestionOp}
            checked={options.SuggestionOp}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <label>
            <img
              className="img-info"
              alt="?"
              src="/static/media/ponto-interrogacao.9ac9cab0.svg"
            />
            <div className="tooltip-text">
              Limite de 20 caracteres por opção
            </div>
          </label>
        </div>
      </div>
      <div className="menu-error-message-container">
        <strong>Mensagem de erro</strong>
      </div>
    </div>
  );
};
